import { lazy } from 'react';
import { pageUrl } from '../services/pageUrl';

export const user_routes = [
  // #########################################################################################
  // #############                Profil                   ###########################
  // #########################################################################################
  {
    exact: true,
    path: pageUrl.profile.edit,
    component: lazy(() => import('../views/user/profil')),
  },
];
